import SessionSearch from './SessionSearch';

export default SessionSearch;
